import type { Easing } from 'framer-motion';

export const transition = {
	accordion: {
		duration: 0.3,
		ease: [0.25, 0, 0.34, 1] as Easing,
	},
	fast: {
		duration: 0.1,
		ease: [0.35, 0, 0.15, 1] as Easing,
	},
	medium: {
		duration: 0.5,
		ease: [0.35, 0, 0.15, 1] as Easing,
	},
	slow: {
		duration: 0.7,
		ease: [0.35, 0, 0.15, 1] as Easing,
	},
};

// Add additional config for motion animations here
export const overlayMotionVariants = {
	fade: {
		animate: { opacity: 1, transition: transition.medium },
		exit: { opacity: 0, transition: transition.medium },
		initial: { opacity: 0 },
	},
	fromBottom: {
		animate: { opacity: 1, transition: transition.medium, y: '0%' },
		exit: { opacity: 0, transition: transition.medium, y: '20%' },
		initial: { opacity: 0, y: '20%' },
	},
	fromLeft: {
		animate: { transition: transition.medium, x: '0%' },
		exit: { transition: transition.medium, x: '-100%' },
		initial: { x: '-100%' },
	},
	fromRight: {
		animate: { transition: transition.medium, x: '0%' },
		exit: { transition: transition.medium, x: '100%' },
		initial: { x: '100%' },
	},
	fromTop: {
		animate: { transition: transition.medium, y: '0%' },
		exit: { transition: transition.medium, y: '-100%' },
		initial: { y: '-100%' },
	},
	search: {
		animate: { transition: transition.medium, x: '0%' },
		exit: { transition: transition.medium, x: '-100%' },
		initial: { x: '-100%' },
	},
	searchMobile: {
		animate: { transition: transition.medium, x: '0%' },
		exit: { transition: transition.medium, x: '-100%' },
		initial: { x: '-100%' },
	},
} as const;

export type OverlayTransitions = keyof typeof overlayMotionVariants;
